'use client';

import { ContextMenu } from './ContextMenu';

interface DiagramMetadata {
  id: string;
  name: string;
  elementCount: number;
  relationshipCount: number;
  updatedAt: number;
}

interface DiagramContextMenuProps {
  x: number;
  y: number;
  diagram: DiagramMetadata;
  onRename: (diagram: DiagramMetadata) => void;
  onDelete: (diagramId: string) => void;
  onClose: () => void;
}

export function DiagramContextMenu({
  x,
  y,
  diagram,
  onRename,
  onDelete,
  onClose,
}: DiagramContextMenuProps) {
  return (
    <ContextMenu
      x={x}
      y={y}
      items={[
        {
          label: 'Rename',
          icon: '✎',
          onClick: () => {
            onRename(diagram);
            onClose();
          },
        },
        {
          label: 'Delete',
          icon: '⚠',
          onClick: () => {
            onDelete(diagram.id);
            onClose();
          },
          danger: true,
        },
      ]}
      onClose={onClose}
    />
  );
}
